export interface DataItem {
  [key: string]: any;
}

export class ListUtils {
  /**
   * Pronalazi indeks stavke u listi na temelju ključa `$itemType`.
   * Ako `$itemType` ne postoji, ispisuje upozorenje i vraća -1.
   *
   * @param data - Array podataka u kojem tražimo
   * @param item - Stavka za koju tražimo indeks
   * @returns Indeks stavke ako postoji, inače -1
   */
  static findMatchingIndex(data: DataItem[], item: DataItem): number {
    if (!item?.['$itemType']) {
      console.warn("Item nema '$itemType':", item);
      return -1;
    }

    const dataKey = `${item['$itemType']}~id` as keyof DataItem;

    return data.findIndex((dataItem) => dataItem[dataKey] === item[dataKey]);
  }
}
